import React from "react";
import "./Careers.css";

function Careers() {
  return (
    <div className="careers-page">

      {/* HERO */}
      <div className="careers-hero-banner">
        <h1 className="careers-title">Careers at Oculus Eye Hospital</h1>
      </div>

      {/* CONTENT */}
      <div className="careers-content">
        <p>
          Want to join us? We are always looking for passionate, caring, and
          dedicated people who want to make a real difference in patients’ lives.
        </p>

        <p>
          If you believe you can contribute to our team, we would love to hear
          from you.
        </p>

        <a
          href="https://forms.gle/Ym5431pWRLho5wPQA"
          target="_blank"
          rel="noopener noreferrer"
          className="btn primary-btn careers-btn"
        >
          Apply Now
        </a>
      </div>

    </div>
  );
}

export default Careers;
